import { checkGoogleAuth } from './methods/checkGoogleAuth';
import { checkPropertyLinked } from './methods/checkPropertyLinked';
import { fetchAnalyticsData } from './methods/fetchAnalyticsData';
import { fetchRealtimeData } from './methods/fetchRealtimeData';

export const analyticsActions = {
  checkGoogleAuth,
  checkPropertyLinked,
  fetchAnalyticsData,
  fetchRealtimeData
};